// src/components/support/past/Request.js
import React, { useEffect, useState } from "react";
import moment from "moment";

import { useAtom } from "jotai";



import { FileText, X } from "lucide-react";

import PastRequestItem from "./PastRequestItem"
import { useRequestProcessor } from "../../requestProcessor";
import { activeChildDetail } from "../../atomstore/store";
import { fetchPastRequests } from "../../queryfunctions/queryfunctions";
import SpinnerLoading from "../common/SpinnerLoading";
import { DEFAULT_FORMAT } from "../common/FootprintDatePicker";

const Request = () => {
    const { useQueryWrapper } = useRequestProcessor();
    const [activeChild] = useAtom(activeChildDetail);
    const [loading, setLoading] = useState(false)



    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const { data: pastRequest, isLoading, refetch } = useQueryWrapper(
        ["pastRequest", "pastRequest" + activeChild?.id],
        () => fetchPastRequests(activeChild),
        {
            onSuccess: (data) => {
                console.log("[Past Request] Loaded:", data);
            },
        }
    );

    return (
        <div className="pt-2 pb-20 space-y-4">

            {(isLoading || loading) && <SpinnerLoading />}

            {!isLoading && (!pastRequest || pastRequest.length === 0) && (
                <div className="flex flex-col items-center justify-center py-16 text-center text-gray-600">
                    <FileText className="w-12 h-12 text-gray-300 mb-3" />
                    <p className="text-base font-semibold">No Requests Found</p>
                    <p className="text-xs text-gray-500 mt-1">No previous requests available.</p>
                </div>
            )}

            {/* Request List */}
            {Array.isArray(pastRequest) &&
                pastRequest.map((item, index) => (
                    <div
                        key={index}
                        className="bg-white rounded-2xl shadow-sm border border-gray-200 
            hover:shadow-lg hover:-translate-y-1 transition-all duration-200 cursor-pointer"
                    >
                        <PastRequestItem item={item} refetch={refetch} setLoading={setLoading} />
                    </div>
                ))}


        </div>
    );
};

export default Request;
